import * as types from "./actionTypes";

export function loadProfile(data) {
  return { type: types.LOAD_PROFILE, data };
}

export function removeProfile() {
  return { type: types.REMOVE_PROFILE };
}

export function decreaseUnreadMessagesCount(data) {
  return { type: types.DECRESE_UNREAD_MESSAGES_COUNT, data };
}
export function updateUnreadMessagesCout(data) {
  return { type: types.UPDATE_UNREAD_MESSAGES_COUNT, data };
}

export function adjustUnreadMessagesCout(data) {
  return { type: types.ADJUST_UNREAD_MESSAGES_COUNT, data };
}
export function adjustUnreadNotificationsCout(data) {
  return { type: types.ADJUST_UNREAD_NOTIFICATIONS_COUNT, data };
}
